'use client';

/**
 * Node 02:50 (2026-09-27) — `/apt/[id]` ISR 전환의 광고 안전장치 조각.
 *
 * 종전엔 서버가 `await searchParams` 로 네이버 유입 파라미터를 보고 미확정 정보를 가렸다
 * (lib/apt/ad-safety.ts · 커밋 71d0ecb3). 그 한 줄이 상세 전체를 동적(ƒ) 렌더로 묶었다.
 * 이제 서버는 쿼리와 무관하게 «항상 가린 버전» 을 낸다(서버 HTML 동일 → 클로킹 표본 불변).
 *
 * 이 섬은 «가림이 기본» 이다: SSR 과 첫 클라이언트 렌더 모두 `hidden` 을 그린다(깜빡 노출 없음).
 * 마운트 후 조건이 맞을 때만 `full` 로 바꾼다 —
 *   · canReveal = 리드폼이 없는 현장(리드폼이 뜨면 그 자체로 광고 문맥 — 종전과 같이 항상 가림)
 *   · 그리고 주소창 쿼리에 광고 유입 파라미터가 없음(isAdTrafficContext 와 같은 규칙)
 */
import { useEffect, useState, type ReactNode } from 'react';
import { isAdTrafficContext, type SearchParamsLike } from '@/lib/apt/ad-safety';

export function shouldRevealUnconfirmed(canReveal: boolean, search: string): boolean {
  if (!canReveal) return false;
  const sp: SearchParamsLike = {};
  new URLSearchParams(search).forEach((v, k) => { sp[k] = v; });
  return !isAdTrafficContext(sp);
}

export default function UnconfirmedReveal({ canReveal, hidden, full }: { canReveal: boolean; hidden: ReactNode; full: ReactNode }) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (shouldRevealUnconfirmed(canReveal, window.location.search)) setShow(true);
  }, [canReveal]);
  return <>{show ? full : hidden}</>;
}
